export const GOTO_PATH = {

    WALL: 'wall',
    COMMENT: 'comment',
    PROFILE: 'profile',
    EDITPROFILE: 'editprofile',
    PORTFOLIO: 'portfolio',
    CATEGORIES: 'categories',
    CATEGORY_PRODUCTS: 'category_products',
    CATALOGUE: 'catalogue',
    LEARNINGHOME: 'learninghome',
    COURSE: 'course',
    CONTENT: 'content',
    BENEFITS: 'benefits',
    STORE: 'store',
    PERIOD: 'period',
    
}